import { render, staticRenderFns } from "./tenderStatus.vue?vue&type=template&id=5ad7105c"
import script from "./tenderStatus.vue?vue&type=script&lang=js"
export * from "./tenderStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports